import { useContext, useEffect, useState, useRef } from "react";
import { NavLink, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ConfigContext } from "../../Context/ConfigContext";
import { OverlayLoader, ShimmerTableRows, Spinner } from "../../Components/Shimmers";
import slugify from "slugify";
import { Helmet } from "react-helmet";
import CarInfoBox from "../Cars/CarInfoBox";
import axios from "axios";
import { toast } from 'react-toastify';
import { AddToCartNotifier } from "../../Components/CartComponents";
import { CartsContext } from "../../Context/CartsContext";
import TFoot from "../../Components/Table/TFoot";
import { UseRewardsPoints } from "../../Components/GlobalFunctions";
import { axiosGet } from "../../Apis/axiosMethods";
import { default_image } from "../../Imgaes";

const ByOEBrands = () => {
    const {
        apiURL,
        apiB2BURL,
        setIsCartDropdownOpen,
        business_delivery_days,
        FavItems,
        business_id,
        business_type,
        currency
    } = useContext(ConfigContext);

    const {
        AddToCart,
        GetCartItemQty,
        loadings,
        AddToFavorite,
        RemoveToFavorite,
        GetStockPolicyItem,
    } = useContext(CartsContext);

    const { t } = useTranslation();
    const { brand } = useParams();

    const [loading, setLoading] = useState(true);

    const [next, setNext] = useState(false);
    const [prev, setPrev] = useState(false);
    const [parts, setParts] = useState([]);
    const [total_records, setTotalRecords] = useState(0);
    const [total_pages, setTotalPages] = useState(0);

    const isAddingRef = useRef(false);

    const [searchParams, setSearchParams] = useSearchParams();

    const pageFromUrl = Number(searchParams.get("page")) || 1;
    const limitFromUrl = Number(searchParams.get("limit")) || 50;


    const [page, setPage] = useState(pageFromUrl);
    const [limit, setLimit] = useState(limitFromUrl);

    useEffect(() => {
        setSearchParams(prev => {
            const params = new URLSearchParams(prev);
            params.set("page", page);
            params.set("limit", limit);
            return params;
        }, { replace: true });
    }, [page, limit]);

    const [keyword, setKeyword] = useState("");
    const [oeKeyword] = useState("");
    const [expandedOEIndexes, setExpandedOEIndexes] = useState({});

    const [isUpdate, setIsUpdate] = useState(false);
    const [addToCartLoading, setAddToCartLoading] = useState(false);

    const navigate = useNavigate();

    // Fetch parts data
    const GetByBrandsWithoutCar = async () => {
        try {
            setLoading(true);
            const response = await axiosGet(`/Parts/${localStorage.getItem('pc_id') ? "GetOEBrandsWithCarParts" : "GetPartsByOEBrandsWithoutCar"}`,
                {
                    pc_id: localStorage.getItem('pc_id'),
                    brand_name: brand,
                    limit,
                    page,
                    part_number: keyword,
                    business_type,
                    currency,
                    lang: "en",
                });

            if (response.data?.success) {

                const data = response.data;

                setParts(data?.data || []);
            }

        } catch (error) {
            console.log(error);
            return null;
        } finally {
            setLoading(false);
        }
    };

    const GetPartsByOEBrandsWithoutCarPagination = async () => {
        try {
            const response = await axiosGet(`/Parts/GetPartsByOEBrandsWithoutCarPagination`, {
                brand_name: brand,
                limit,
                page,
                part_number: keyword,
                business_type,
                pc_id: localStorage.getItem('pc_id'),
            });

            if (response.data?.success) {

                const data = response.data;
                setPage(data?.page || 1);
                setTotalPages(data?.total_pages)
                setTotalRecords(data?.total_records)
                setNext(data?.next)
                setPage(data?.page)
                setPrev(data?.prev)
            }

        } catch (error) {
            console.log(error);
            return null;
        }
    };

    useEffect(() => {
        GetPartsByOEBrandsWithoutCarPagination();
    }, [isUpdate, page, limit]);

    useEffect(() => {
        GetByBrandsWithoutCar();
    }, [isUpdate, page, limit]);

    const getSerialNumber = (index) => {
        return (page - 1) * limit + index + 1;
    };

    const handleAddToCart = async (item, url) => {
        if (isAddingRef.current) return;

        isAddingRef.current = true;
        setAddToCartLoading(true);

        try {
            const prev_qty = Number(await GetCartItemQty(item.ART_SEARCH_NUMBER) || 0);

            const availableQty = Number(
                item?.stock_available_qty ??
                item?.VD_QTY ??
                0
            );

            if (!availableQty || availableQty <= 0) {
                toast.success(
                    <AddToCartNotifier
                        item_name={"We dont have stock for this part"}
                        item_img={""}
                    />
                );
                return;
            }

            // Get Stock Policy
            const stockPolicy = await GetStockPolicyItem(
                item?.ART_SEARCH_NUMBER,
                1,
                item?.stock_sup_id,
                item?.stock_brand_name
            );

            const minQty = Number(stockPolicy?.policy_min_qty || 1);

            // Default Add Qty
            let addQty = minQty;

            // Remaining Stock
            const remainingStock = availableQty - prev_qty;

            // If remaining stock is less than min qty,
            // then add remaining stock
            if (remainingStock < minQty && remainingStock > 0) {
                addQty = remainingStock;
            }

            // No stock left
            if (remainingStock <= 0) {
                toast.success(
                    <AddToCartNotifier
                        item_name={"We dont have enough stock for this part"}
                        item_img={""}
                    />
                );
                return;
            }

            const partImg = item?.MEDIA_SOURCE
                ? item.MEDIA_SOURCE
                : `${apiURL}/public/placeholder_category.jpeg`;

            const main_data = {
                ART_ID: item?.ART_ID,
                ART_ARTICLE_NR: item?.ART_SEARCH_NUMBER,
                PRODUCT_GROUP_EN: item?.ART_PRODUCT_NAME,
                stock_price_mrp: item?.stock_price_mrp,
                VD_BG_PRICE: item?.stock_bg_price,
                VD_BB_PRICE: item?.stock_bb_price,
                VD_QTY: item?.stock_available_qty,
                ART_SUP_ID: 0,
                ART_SUP_BRAND: item?.stock_brand_name,
                inventory_store_id: item?.inventory_store_id,
                stock_oe: 1,
                stock_delivery_days: item?.stock_delivery_days
            };

            await AddToCart(main_data, addQty, partImg, url);

            setIsCartDropdownOpen(true);
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });

        } catch (error) {
            console.error("Add to cart error:", error);

            toast.error(
                <AddToCartNotifier
                    item_name={"Something went wrong"}
                    item_img={""}
                />
            );

        } finally {
            setAddToCartLoading(false);
            isAddingRef.current = false;
        }
    };

    const handleAddToFavorite = async (item, url) => {
        try {
            const partImg = `${item?.MEDIA_SOURCE}` || `${apiURL}/public/placeholder_category.jpeg`;
            const data = {
                business_id,
                item_id: item.ART_ID,
                item_number: item.ART_ARTICLE_NR.replace(/[^a-zA-Z0-9]/g, ''),
                item_title: item.ART_PRODUCT_NAME,
                item_sup_id: 0,
                item_mrp: item.stock_price_mrp,
                item_price: Number(business_type) === 1 ? item?.stock_bg_price : item?.stock_bb_price,
                item_qty: 1,
                item_img_url: partImg,
                item_url: url,
                max_qty: item?.stock_available_qty,
                item_store_id: item?.inventory_store_id,
                item_stock_oe: item?.stock_oe,
                item_delivery_days: item?.stock_delivery_days,
                item_brand_name: item?.stock_brand_name
            };

            await AddToFavorite(data);
        } catch (error) {
            toast.error("Error adding to favorites.");
        }
    };

    const toggleOEExpand = (rowIdx) => {
        setExpandedOEIndexes(prev => ({
            ...prev,
            [rowIdx]: !prev[rowIdx]
        }));
    };

    const handleRemoveToFavorite = async (part, url) => {
        try {
            await RemoveToFavorite(part);
        } catch (error) {
            // setLoading(false);
        }
    }

    const handleSearch = () => {
        if (keyword || oeKeyword) {
            setIsUpdate(prev => !prev);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };

    const handleClearSearch = () => {
        if (keyword) {
            setIsUpdate(prev => !prev);
            setKeyword("");
        }
    };

    const getPageNumbers = () => {
        const pages = [];
        const total = total_pages;
        const windowSize = 5;

        let start = page;
        let end = page + windowSize - 1;

        // If end exceeds total pages
        if (end > total) {
            end = total;
            start = total - windowSize + 1;
        }

        // If start goes below 1
        if (start < 1) {
            start = 1;
        }

        for (let i = start; i <= end; i++) {
            pages.push(i);
        }

        return pages;
    };

    return (
        <>
            {loading ? (
                <div style={{ height: "70vh" }}>
                    <OverlayLoader />
                </div>
            )
                :
                <div className="header-bottom d-none d-lg-block">
                    <Helmet><title>Shop By Genuine Brand</title></Helmet>
                    <div className="container">
                        <CarInfoBox />

                        <h4 className="mt-3" id="parts-table-top">
                            {brand} Part List
                            {parts.length > 0 && <small> (Total Parts: {total_records})</small>}
                        </h4>


                        <div className="row">
                            <div className="col-md-4">
                                <div className="input-group">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder={t("Search by Part Number")}
                                        value={keyword}
                                        onChange={(e) => setKeyword(e.target.value)}
                                        onKeyPress={handleKeyPress}
                                    />
                                </div>
                            </div>

                            <div className="col-md-4">
                                <button
                                    className="btn btn-primary mr-2"
                                    onClick={handleSearch}
                                >
                                    <i className="fas fa-search"></i> {t("Search")}
                                </button>

                                <button
                                    className="btn btn-secondary"
                                    onClick={handleClearSearch}
                                >
                                    <i className="fas fa-times"></i> {t("Clear")}
                                </button>
                            </div>
                        </div>

                        <table className="table table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th width="10">SR No.</th>
                                    <th style={{ verticalAlign: 'middle' }} width="400">Part Name</th>
                                    <th style={{ minWidth: '150px', verticalAlign: 'middle' }}>Part Number</th>
                                    <th style={{ verticalAlign: 'middle' }}>Picture</th>
                                    <th>Available QTY</th>
                                    <th style={{ verticalAlign: 'middle' }}>
                                        Offer Price <small style={{ color: "red", fontWeight: "bold" }}>excl. 5.0% VAT</small>
                                    </th>

                                    <th style={{ verticalAlign: 'middle' }}>Similar Parts</th>
                                    {
                                        currency.toLowerCase() !== "usd" &&
                                        <th style={{ verticalAlign: 'middle' }}>Delivery Days</th>
                                    }
                                    <th style={{ verticalAlign: 'middle' }}>Details</th>
                                    <th style={{ verticalAlign: 'middle' }}>Buy</th>
                                    <th style={{ verticalAlign: 'middle' }}>Add To Favorites</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading &&
                                    <ShimmerTableRows colspan={12} rows={limit} />
                                }

                                {!loading && parts.length > 0 && parts.map((part, index) => {

                                    const productGroup = part?.ART_PRODUCT_NAME
                                        ?.toString()
                                        .trim()
                                        .replace(/[\/,]+/g, "-")
                                        .replace(/\s+/g, "-")
                                        .replace(/-+/g, "-");

                                    const url = `/OE-Spare-Parts/Details/${productGroup}-${part?.ART_SEARCH_NUMBER}/${part?.ART_SUP_BRAND}`;

                                    const isFavorite = FavItems && FavItems.find(item =>
                                        item.item_number === part.ART_SEARCH_NUMBER &&
                                        item?.item_brand_name === part?.stock_brand_name);

                                    const beforePrice =
                                        Number(business_type) === 1
                                            ? part?.stock_before_bg_price
                                            : part?.stock_before_bb_price;

                                    const inStock = (part?.stock_available_qty || 0) > 0;

                                    const price = Number(business_type) === 1 ?
                                        Number(part?.stock_bg_price).toFixed(2)
                                        :
                                        Number(part?.stock_bb_price).toFixed(2)


                                    const get_rewards_points = UseRewardsPoints(price);



                                    return (
                                        <tr key={part.ART_ID}>

                                            <td>{getSerialNumber(index)}</td>

                                            <td width="20%" style={{ verticalAlign: 'middle' }}>
                                                <NavLink to={url} onClick={() => {
                                                    window.scrollTo({
                                                        top: 0,
                                                        behavior: "smooth",
                                                    });
                                                }}>
                                                    {part && part.ART_PRODUCT_NAME}
                                                </NavLink>
                                            </td>

                                            <td width="10%" style={{ verticalAlign: 'middle' }}>
                                                <NavLink onClick={() => {
                                                    window.scrollTo({
                                                        top: 0,
                                                        behavior: "smooth",
                                                    });
                                                }} to={url}>
                                                    {part.ART_ARTICLE_NR}
                                                </NavLink>
                                            </td>

                                            <td>
                                                <img
                                                    src={`${part?.MEDIA_SOURCE}`}
                                                    onError={(e) => {
                                                        e.target.src = default_image;
                                                    }}
                                                    style={{ width: '50px', objectFit: 'contain' }}
                                                    alt={part?.ART_PRODUCT_NAME || 'Part Image'}
                                                />

                                            </td>

                                            <td style={{ verticalAlign: 'middle' }}>
                                                {inStock ? part?.stock_available_qty
                                                    :
                                                    <div className="text-center">
                                                        <span className="badge badge-danger">Out of stock</span>
                                                    </div>
                                                }
                                            </td>

                                            {/* <td style={{ verticalAlign: 'middle' }}>
                                                <div className="d-flex" style={{ alignItems: "center" }}>

                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'flex-start',
                                                        }}
                                                    >
                                                        <span style={{ fontWeight: 600, fontSize: "14px", }}>
                                                            {part?.display_price}
                                                        </span>
                                                    </div>

                                                    {
                                                        beforePrice > 0 && beforePrice > part?.display_price &&
                                                        <small className="text-muted d-flex">
                                                            <span style={{ marginRight: "3px" }}>Was: </span>
                                                            <del>
                                                                {beforePrice.toFixed(2)}{currency?.toUpperCase()}
                                                            </del>
                                                        </small>
                                                    }

                                                </div>

                                            </td> */}

                                            <td width="16%" style={{ verticalAlign: "middle" }}>
                                                <div>
                                                    <div
                                                        className="d-flex align-items-center"
                                                        style={{
                                                            gap: "8px",
                                                            whiteSpace: "nowrap"
                                                        }}
                                                    >
                                                        <span style={{ fontWeight: 600, fontSize: "14px" }}>
                                                            {part?.display_price}
                                                        </span>

                                                        {beforePrice > 0 && beforePrice > part?.display_price && (
                                                            <small
                                                                className="text-muted"
                                                                style={{ whiteSpace: "nowrap" }}
                                                            >
                                                                Was:{" "}
                                                                <del>
                                                                    {beforePrice.toFixed(2)}{currency?.toUpperCase()}
                                                                </del>
                                                            </small>
                                                        )}
                                                    </div>

                                                    {
                                                        currency.toLowerCase() !== "usd" &&

                                                        <div
                                                            style={{
                                                                fontSize: "12px",
                                                                marginTop: "4px",
                                                                fontWeight: 500
                                                            }}
                                                        >
                                                            <span style={{ color: "#000" }}>
                                                                You will get{" "}
                                                            </span>

                                                            <span className="text-primary" style={{ fontWeight: 700 }}>
                                                                {get_rewards_points} rewards points {" "}
                                                            </span>

                                                            <span style={{ color: "#000" }}>
                                                                On This
                                                            </span>
                                                        </div>
                                                    }
                                                </div>
                                            </td>


                                            <td style={{ verticalAlign: 'middle' }}>
                                                {(() => {
                                                    // const oeNumbers = part.OEM_NUMBERS || [];
                                                    const oeNumbers =
                                                        typeof part.OE_NUMBERS_CROSS === "string"
                                                            ? JSON.parse(part.OE_NUMBERS_CROSS || "[]")
                                                            : part.OE_NUMBERS_CROSS || [];

                                                    const seen = new Set();
                                                    const uniqueOEs = [];

                                                    for (const oe of oeNumbers) {
                                                        if (
                                                            oe.ARL_DISPLAY_NR &&
                                                            oe.ARL_DISPLAY_NR !== part.ART_ARTICLE_NR &&
                                                            !seen.has(oe.ARL_DISPLAY_NR)
                                                        ) {
                                                            uniqueOEs.push({
                                                                display: oe.ARL_DISPLAY_NR,
                                                                stock: oe.stock_available_qty ?? 0
                                                            });

                                                            seen.add(oe.ARL_DISPLAY_NR);
                                                        }
                                                    }

                                                    if (uniqueOEs.length === 0) return <span>-</span>;

                                                    const isExpanded = !!expandedOEIndexes?.[part.ART_ID];

                                                    const renderOEs = isExpanded
                                                        ? uniqueOEs
                                                        : uniqueOEs.slice(0, 2);

                                                    return (
                                                        <>
                                                            {renderOEs.map((oeObj, idx) => {
                                                                const oeColor =
                                                                    oeObj.stock > 0 ? "#007bff" : "#cc000b";

                                                                const toggleColor =
                                                                    oeObj.stock > 0 ? "#cc000b" : "#007bff";

                                                                return (
                                                                    <span key={oeObj.display}>
                                                                        <NavLink
                                                                            style={{ color: oeColor }}
                                                                            to={
                                                                                oeObj.stock > 0
                                                                                    ? url
                                                                                    : `/Spare-Parts/OEM/${part.PRODUCT_GROUP_EN?.toString()
                                                                                        .trim()
                                                                                        .replace(/,/g, "")
                                                                                        .replace(/\s+/g, "-")
                                                                                    }-${oeObj.display.replace(/[^a-zA-Z0-9]/g, '')}`
                                                                            }
                                                                            onClick={() => {
                                                                                window.scrollTo({
                                                                                    top: 0,
                                                                                    behavior: "smooth",
                                                                                });
                                                                            }}
                                                                        >

                                                                            {oeObj.display}
                                                                        </NavLink>

                                                                        {idx < renderOEs.length - 1 ? ", " : ""}

                                                                        {/* Toggle Button */}
                                                                        {idx === renderOEs.length - 1 &&
                                                                            uniqueOEs.length > 2 && (
                                                                                <span
                                                                                    style={{
                                                                                        color: toggleColor,
                                                                                        cursor: "pointer",
                                                                                        marginLeft: 4,
                                                                                        fontWeight: 500
                                                                                    }}
                                                                                    onClick={() =>
                                                                                        toggleOEExpand(part.ART_ID)
                                                                                    }
                                                                                >
                                                                                    {isExpanded ? " - less" : " +more"}
                                                                                </span>
                                                                            )}
                                                                    </span>
                                                                );
                                                            })}
                                                        </>
                                                    );
                                                })()}
                                            </td>

                                            {

                                                currency.toLowerCase() !== "usd" &&
                                                <td style={{ verticalAlign: 'middle' }}>
                                                    {(() => {
                                                        const total =
                                                            (part?.stock_delivery_days || 0) +
                                                            (business_delivery_days || 0);

                                                        return total === 0
                                                            ? "Same Day"
                                                            : `${total} ${total === 1 ? "Day" : "Days"}`;
                                                    })()}
                                                </td>
                                            }


                                            <td style={{ verticalAlign: 'middle' }}>
                                                <button onClick={() => {
                                                    window.scrollTo({
                                                        top: 0,
                                                        behavior: "smooth",
                                                    });
                                                    navigate(url)
                                                }
                                                } className="btn btn-sm btn-info"> <i className="fas fa-info-circle"></i> Details </button>
                                            </td>

                                            <td style={{ verticalAlign: 'middle' }}>
                                                <div className="btn-group" role="group" aria-label="Cart and Favorite">

                                                    <button
                                                        className="btn btn-sm btn-dark"
                                                        type="button"
                                                        onClick={() => handleAddToCart(part, url)}
                                                        disabled={
                                                            loadings ||
                                                            addToCartLoading ||
                                                            isAddingRef.current ||
                                                            part?.display_price <= 0
                                                        }
                                                    >
                                                        <i className="fas fa-cart-plus"></i> Buy
                                                    </button>
                                                </div>
                                            </td>
                                            <td style={{ verticalAlign: 'middle' }}>
                                                <div onClick={() => {
                                                    if (isFavorite) {
                                                        handleRemoveToFavorite(part)
                                                    } else {
                                                        handleAddToFavorite(part, url)
                                                    }
                                                }}
                                                    style={{ cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", textAlign: "center" }}
                                                >
                                                    <i
                                                        className={`isFavorite ${isFavorite ? 'fas' : 'far'} fa-heart favHeart ${isFavorite ? 'active' : ''}`}
                                                        style={{ fontSize: '18px' }}
                                                    >
                                                    </i>
                                                    <span style={{ fontSize: '14px', fontWeight: '500', paddingBottom: '2px' }}></span>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })}

                                {!loading && parts.length === 0 && (
                                    <tr>
                                        <td colSpan={11}>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    width: '100%'
                                                }}
                                            >
                                                <div className="noresult" style={{ display: 'block', width: '100%' }}>
                                                    <div className="text-center">
                                                        <lord-icon
                                                            src="https://cdn.lordicon.com/msoeawqm.json"
                                                            trigger="loop"
                                                            colors="primary:#121331,secondary:#08a88a"
                                                            style={{ width: '75px', height: '75px' }} />
                                                        <h5 className="">Sorry! No Result Found</h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                            {
                                total_pages > 1 &&
                                <TFoot
                                    page={page}
                                    limit={limit}
                                    total_records={total_records}
                                    next={next}
                                    prev={prev}
                                    getPageNumbers={getPageNumbers}
                                    setSearchParams={setSearchParams}
                                    setPage={setPage}
                                    setLimit={setLimit}
                                    total_pages={total_pages}
                                />
                            }

                        </table>
                    </div>
                </div >
            }
        </>
    );
};

export default ByOEBrands;